js_add_local()
function js_add_local(){
    document.addEventListener('DOMContentLoaded', initAddLocal)
}

// inicializar add local
function initAddLocal() {
    const buttons = document.querySelectorAll('.js-add-local__button')
    
    if (buttons != null) {
        init()
    }
    
    function init(){
        for (let i = 0; i < buttons.length; i++) {
            buttons[i].addEventListener('click', () => {
                agrearLocal(buttons[i])
            })
        }
    }

    function agrearLocal(button) {
        const content = document.querySelector('.js-add-local__content.is-tab')
        localStorage.setItem(`${button.dataset.local}`, `${content.dataset.tab}`)
        
        if (content.dataset.pasos) {
            localStorage.setItem(`wine_pasos`, `${content.dataset.pasos}`)
        }

        if (content.dataset.price) {
            localStorage.setItem(`wine_price`, `${content.dataset.price}`)
        }

        if (content.dataset.tags) {
            localStorage.setItem(`wine_tags`, `${content.dataset.tags}`)
        }

        window.location = button.href
    }
}
